import { Skeleton } from '@/components/ui/skeleton';

/** Four full-width bars while a tab's list loads; `rowClassName` sets their height. */
export function RowsSkeleton({ rowClassName }: { rowClassName: string }) {
  return (
    <div className="flex flex-col gap-2 p-4" aria-busy="true">
      {[0, 1, 2, 3].map((i) => (
        <Skeleton key={i} className={rowClassName} />
      ))}
    </div>
  );
}
